module.exports = __webpack_public_path__ + "static/media/thumb_videonly_503x503.f96d7f73.jpg";